import { createSelector } from '@reduxjs/toolkit';
import { selfSelector } from './self';

const pushLoadingSelector = createSelector(selfSelector, (state) => state.isLoading );

export default pushLoadingSelector;
